import React from 'react';
import { ToastService } from '@iamsoftware/react-hooks';
import { useDataTable } from 'src/hooks/useAppDataTable';
import { useNavigate } from 'react-router-dom';
import { AgreementService } from '../../../../../service/AgreementService';
import { DocumentNameCell } from '../DocumentNameCell';

interface CancelledTabProps {
    loadCanvas: (file: any) => void;
    setReload?: (reloadFn: () => void) => void;
    headerActions?: React.ReactNode;
}

export const CancelledTab: React.FC<CancelledTabProps> = ({
    loadCanvas,
    setReload,
    headerActions
}) => {
    const navigate = useNavigate();
    const columns: any[] = [
        {
            field: 'agreementName',
            header: 'Tên tài liệu',
            width: 100,
            matchMode: 'contains',
            dataType: 'custom' as const,
            customCell(row: any) {
                return (
                    <DocumentNameCell
                        rowData={row}
                        onClick={() => navigate(`/quan-ly-tai-lieu/tai-lieu/${row.agreementId}?mode=view`)}
                    />
                );
            }
        },
        { field: 'agreementNo', header: 'Mã tài liệu', width: 140, matchMode: 'contains' },
        { field: 'agreementTypeName', header: 'Loại tài liệu', width: 160, matchMode: 'contains' },
        // {
        //     field: 'statusDescription',
        //     header: 'Trạng thái',
        //     width: 200,
        //     dataType: 'custom' as const,
        //     customCell(row: any) {
        //         return <Tag value="Đã hủy" severity="danger" />;
        //     }
        // },
        // {
        //     field: 'mainContent',
        //     header: 'File ký',
        //     width: 220,
        //     dataType: 'custom' as const,
        //     customCell(row: any) {
        //         if (!row.mainContent) return <span className="text-gray-500">Chưa có file</span>;
        //         return (
        //             <div className="flex align-items-center gap-2">
        //                 <i className={`pi ${row.mainContent.contentType === 'application/pdf' ? 'pi-file-pdf' : 'pi-file-word'} text-xl`}></i>
        //                 <div>
        //                     <div className="font-medium">{row.mainContent.fileName}</div>
        //                     <small className="text-gray-500">{row.mainContent.contentType?.split('/')?.[1]?.toUpperCase()}</small>
        //                 </div>
        //             </div>
        //         );
        //     }
        // },
        {
            field: 'expiryDate',
            header: 'Thời gian',
            width: 180,
            dataType: 'custom',
            customCell(rowData: any): any {
                const formatLocal = (value?: any) => {
                    if (!value) return null;
                    const d = new Date(value);
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    const HH = String(d.getHours()).padStart(2, '0');
                    const MM = String(d.getMinutes()).padStart(2, '0');
                    const SS = String(d.getSeconds()).padStart(2, '0');
                    return `${dd}/${mm}/${yyyy} ${HH}:${MM}:${SS}`;
                };

                const expiryText = rowData.expiryDate ? formatLocal(rowData.expiryDate) : null;
                const updatedText = rowData.lastUpdatedStamp ? formatLocal(rowData.lastUpdatedStamp) : null;

                if (!expiryText && !updatedText) return null;

                return (
                    <div className="text-sm">
                        {expiryText && <div className={updatedText ? 'mb-1' : undefined}>{expiryText}</div>}
                        {updatedText && (
                            <div>{updatedText}</div>
                        )}
                    </div>
                );
            }
        }
    ];

    const mapListResult = (result: any) => {
        if (result.listData && Array.isArray(result.listData)) {
            result.listData = result.listData.map((item: any) => ({
                ...item,
                mainContent: item.mainFileName || item.mainContentType ? {
                    fileName: item.mainFileName,
                    contentType: item.mainContentType,
                    contentLocation: item.referenceContentLocation || item.mainContentLocation,
                    fileId: item.fileId || item.mainFileId || item.mainContentId,
                    googleFileId: item.fileId || item.mainFileId || item.mainContentId,
                    referenceFileId: item.referenceContentLocation
                } : null
            }));
        }
        const total = result.totalRecords ?? (result.listData || []).length;
        return {
            listData: result.listData || [],
            totalRecords: total,
            totalCount: total
        };
    };

    const { render: renderCancelled, reloadLazyData: reloadCancelled } = useDataTable({
        recordLabel: 'tài liệu đã hủy',
        headerActions,
        dataKey: 'agreementId',
        indexColumnWidth: 56,
        actionColumnWidth: 170,
        columns: columns,
        getList: lazyLoadEvent => {
            return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_CANCELLED').then(mapListResult);
        },
        initActions(items: Array<any>) {
            items?.forEach(item => {
                const mainFileId = item?.mainContent?.fileId || item?.fileId;
                const hasMainFileUrl = item?.mainContent?.contentLocation;
                const actions: any[] = [];

                if (mainFileId || hasMainFileUrl) {
                    actions.push({
                        icon: 'pi pi-external-link',
                        title: 'Xem file',
                        className: 'p-button-help',
                        command: () => {
                            if (item.mainContent) {
                                loadCanvas(item.mainContent);
                            } else {
                                navigate(`/quan-ly-tai-lieu/tai-lieu/${item.agreementId}?mode=view`);
                            }
                        }
                    });
                } else {
                    actions.push({
                        icon: 'pi pi-eye',
                        title: 'Xem chi tiết',
                        className: 'p-button-info',
                        command: () => navigate(`/quan-ly-tai-lieu/tai-lieu/${item.agreementId}?mode=view`)
                    });
                }
                
                item.actions = actions;
            });
        },
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    React.useEffect(() => {
        if (setReload) setReload(reloadCancelled);
    }, [reloadCancelled, setReload]);

    return (
        <div className="tai-lieu-ky-table">
            {renderCancelled()}
        </div>
    );
};
